import I18n from 'i18n-js';
import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'reactstrap';
import PaginationConst from '../../blocks/consts/PaginationConst';
import Faq from "../../models/faq/Faq";
import ContentLayout from '../core/ContentLayout';
import ArrowDownwardIcon from '@material-ui/icons/KeyboardArrowDown';
import ArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import PrometTableFooter from '../shared/promet-table/PrometTableFooter';
import HorizontalDivider from '../shared/HorizontalDivider';
import { connect, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { FaqType } from '../../models/faq/FaqType';
import { getFaqActions } from '../../store/faq/actions';

type Props = typeof mapDispatchToProps;

const FrequentlyAskedQuestions = (props: Props) => {
    const [divVisibility, setDivVisibility] = useState<boolean[] | undefined>([]);
    const pageNumber = useRef<number>(PaginationConst.FirstPage);
    const pageSize = useRef<number>(PaginationConst.DefaultPageSize);

    const faqs = useSelector((state: ApplicationState) => state.faq.faqs);
    const totalCount = useSelector((state: ApplicationState) => state.faq.faqTotalCount);

    useEffect(() => {
        getFaqs();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const hiddenDivs: boolean[] = faqs?.map(e => { return false }) || [];
        setDivVisibility(hiddenDivs);
    }, [faqs]); // eslint-disable-line react-hooks/exhaustive-deps

    const getFaqs = () => {
        props.getFaqs({ type: FaqType.FAQ, pageNumber: pageNumber.current, pageSize: pageSize.current });
    }

    const onPageChange = (page: number) => {
        pageNumber.current = page;
        getFaqs();
    }

    const onSizeChange = (size: number) => {
        pageNumber.current = PaginationConst.FirstPage;
        pageSize.current = size;
        getFaqs();
    }

    const onVisibilityChange = (index: number) => {
        setDivVisibility((prevState) => prevState?.map((item, idx) => (idx === index ? !item : item)));
    };

    const isDivVisible = (index: number) => {
        return divVisibility?.length && divVisibility[index];
    };

    const renderFaqs = () => {
        return faqs?.map((faq: Faq, index: number) => {
            return (
                <div key={index} className='mt-4 mb-4'>
                    <div onClick={() => onVisibilityChange(index)} className="d-flex align-items-center justify-content-between cursor-pointer">
                        <div className="float-left d-flex align-items-center">
                            <span className="primary-color font-weight-500">
                                {faq.title}
                            </span>
                        </div>
                        <div className="float-right d-flex align-items-center">
                            {
                                isDivVisible(index)
                                    ? <ArrowDownwardIcon className='text-primary' />
                                    : <ArrowRightIcon className='text-primary' />
                            }
                        </div>
                    </div>
                    <HorizontalDivider smallerMargin />
                    {
                        isDivVisible(index) &&
                        <div className="faq p-3" dangerouslySetInnerHTML={{ __html: faq.htmlContent }} />
                    }
                </div>
            )
        });
    };

    return (
        <ContentLayout titleTranslateId='frequentlyAskedQuestions.title'>
            {
                faqs && faqs.length > 0 &&
                <>
                    <Row>
                        <Col xl={12} md={12} sm={12}>
                            {renderFaqs()}
                        </Col>
                    </Row>
                    {
                        totalCount && totalCount >= PaginationConst.DefaultPageSize &&
                        <PrometTableFooter
                            onPageChange={onPageChange}
                            onSizeChange={onSizeChange}
                            total={totalCount}
                            size={pageSize.current}
                            page={pageNumber.current}
                            dataCount={faqs.length}
                        />
                    }
                </>
            }
            {
                faqs && !faqs.length &&
                <div className='d-flex justify-content-center mb-5 pb-5 mt-5 pt-5'>
                    <span>{I18n.t('noResults')}</span>
                </div>
            }
        </ContentLayout>
    );
}

const mapDispatchToProps = {
    getFaqs: getFaqActions.request
};

export default connect(null, mapDispatchToProps)(FrequentlyAskedQuestions as any);
